import { MutableRefObject } from 'react'

// On web, pretty much any element is safely focusable.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const focusableRef = (ref?: MutableRefObject<any>) => ref

export default focusableRef
